import AppleHealthChartsWrapper from 'pages/Dashboard/components/AppleHealthChartsWrapper';
import React from 'react';
import AppleHealthActivityChart from 'pages/Dashboard/components/AppleHealthActivityChart';
import AppleHealthActivitySummaryChart, { DataKey } from 'pages/Dashboard/components/AppleHealthActivitySummaryChart';
import { TimeFrameOptions, waypointBarSizeMap } from 'pages/Dashboard/utils/trackingUtils';
import { WaypointSource, WaypointTracking } from 'pages/Dashboard/types/waypoints.types';

interface ActivityComponentProps {
  timeFrame: TimeFrameOptions;
  onChangeTimeFrame: (v: string) => void;
  appleHealthActivityData: WaypointTracking[];
  appleHealthActivityGoals: Record<string, string>[];
  appleHealthActivityAvgData: { value: number; unit: string } | undefined;
  sourceOptions: { label: string; value: string; isSelected: boolean }[];
  sourceId: string;
  onChangeSource: (id: string) => void;
  yAxisProps: { startTime: number; endTime: number; ticks: number[]; isInDays: boolean };
  hasStandHours: boolean;
  sourceObject: Partial<WaypointSource>;
  isLoading: boolean;
  hasData: boolean;
  gridSize?: number;
}

function ActivityComponent({
  timeFrame,
  onChangeTimeFrame,
  appleHealthActivityData,
  appleHealthActivityGoals,
  appleHealthActivityAvgData,
  sourceOptions,
  sourceId,
  onChangeSource,
  yAxisProps,
  hasStandHours,
  sourceObject,
  isLoading,
  hasData,
  gridSize = 6,
}: ActivityComponentProps) {
  const getActivityTitle = hasStandHours ? 'Physical activities' : 'Active Energy Burned';
  const activityTitle = sourceObject?.sourcePlatform === 'android'
    ? 'Total Calories Burned' : getActivityTitle;
  const activityDataKey = sourceObject?.sourcePlatform === 'ios' ? DataKey.ActiveEnergyBurned : DataKey.TotalCaloriesBurned;
  return (
    <>
      {hasStandHours && (
        <AppleHealthChartsWrapper
          title={activityTitle}
          isLoading={isLoading}
          sourceObject={sourceObject}
          timeFrame={timeFrame}
          onTimeFrameChange={onChangeTimeFrame}
          noData={!hasData}
          gridSize={gridSize}
          renderChart={(
            <AppleHealthActivityChart
              chartData={appleHealthActivityData}
              chartGoals={appleHealthActivityGoals}
              yAxisProps={yAxisProps}
              barSize={waypointBarSizeMap[`${timeFrame}-${6}`]}
            />
          )}
        />
      )}
      {!hasStandHours && (
        <AppleHealthChartsWrapper
          title={activityTitle}
          isLoading={isLoading}
          timeFrame={timeFrame}
          sourceObject={sourceObject}
          onTimeFrameChange={onChangeTimeFrame}
          noData={!hasData}
          gridSize={gridSize}
          renderChart={(
            <AppleHealthActivitySummaryChart
              chartData={appleHealthActivityData}
              dataKey={activityDataKey}
              units='kCal'
              average={appleHealthActivityAvgData}
              yAxisProps={yAxisProps}
              yAxisDefinition='Calories'
              barSize={waypointBarSizeMap[`${timeFrame}-${6}`]}
              sourceId={sourceId}
              sourceOptions={sourceOptions}
              setSourceId={onChangeSource}
            />
          )}
        />
      )}
    </>
  );
}

export default ActivityComponent;
